var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Glyph"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17 9.1v-3.1a5 5 0 0 0 -10 0v3.1a5 5 0 0 0 -4 4.9v4a5 5 0 0 0 5 5h8a5 5 0 0 0 5-5v-4a5 5 0 0 0 -4-4.9zm-8-3.1a3 3 0 0 1 6 0v3h-6zm6.16 9.38-2.72 2.67a1 1 0 0 1 -.7.28 1 1 0 0 1 -.7-.28l-1.29-1.27a1 1 0 1 1 1.41-1.42l.58.57 2-2a1 1 0 0 1 1.42 0 1 1 0 0 1 0 1.45z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockCheck);
export default __webpack_public_path__ + "static/media/lock_check.040c52a0f05f9b2cab77774694e6b65b.svg";
export { ForwardRef as ReactComponent };